/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.10",
    versionName: "0.2.0-nightly.2026.2.10",
    versionChannel: "nightly",
    buildDate: "2026-02-10T00:13:58.972Z",
    commitHash: "b02ec06ebfdf65ff105741b5cbd101c488314b74",
};
